export default {
	"order.NoActivationAddress": "無激活地址！",
	"order.PleaseTryAgainLater": "請稍後重試",
	"order.toFillInTheShippingAddress": "去填寫收貨地址",
	"order.deactivateProduct": "去激活商品",
	"order.paymentSuccessful": "支付成功"
}